export enum PmmlOpType {
    //default null
    NULL_VALUE="",
    //original values 
    CONTINUOUS = "CONTINUOUS",
    CATEGORICAL = "CATEGORICAL"
}